import dayjs from "dayjs";
import i18next from "i18next";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaAngleDoubleRight } from "react-icons/fa";
import { TbListSearch } from "react-icons/tb";
import { useSelector } from "react-redux";
import { getGiftList, getUsedGiftList } from "../../../api/getApi";
import LoadingReward from "../../../components/Loading/LoadingReward";
import NotFound from "../../../components/ProgressBlock/NotFound";
import useDeviceType from "../../../hook/useDeviceType";
import List from "../../Promotion/components/LIST";
import RewardCard from "../../Rewards/components/RewardCard";
import UsedRewardCard from "../../Rewards/components/usedRewardCard";

const RewardList = () => {
  const { t } = useTranslation();
  const i18n_rewards = (key) => t(`reward.${key}`);

  const promotionList = List();
  const [apiCalling, setApiCalling] = useState(false);
  const [promotionListData, setPromotionListData] = useState([]);
  const [giftList, setGiftList] = useState([]);
  const playGameType = useSelector((state) => state?.isGameConfig?.game_type);
  const globalTrigger = useSelector((state) => state?.isGlobalTrigger);

  const isMobile = useDeviceType() === "Mobile";
  const deviceType = useDeviceType();

  const sectionRef = useRef(null);
  const [isEndReached, setIsEndReached] = useState(false);

  useEffect(() => {
    setApiCalling(true);

    getGiftList()
      .then((data) => {
        setPromotionListData(data.data);
      })
      .catch((err) => {})
      .finally(() => {
        setApiCalling(false);
      });
    getUsedGiftList({
      str_date: `2018-01-01 00:00:00`,
      end_date: `2030-01-01 00:00:00`,
    }).then((data) => {
      setGiftList(
        data.data.filter((item) => {
          return item.isuse === 0;
        })
      );
    });
  }, [globalTrigger]);

  const updateList = useMemo(() => {
    if (promotionListData) {
      return promotionListData
        .map((item) => {
          const findGiftInPromotionList = promotionList.find(
            (promotionItem) => {
              return promotionItem.good_uid == item.good_uid;
            }
          );
          // 檢查是否找到了符合條件的項目
          if (findGiftInPromotionList) {
            return {
              ...item,
              conditionKeys: findGiftInPromotionList.conditionKeys,
              promo_label: findGiftInPromotionList.title,
              navigate: findGiftInPromotionList.navigate,
              buttonText: findGiftInPromotionList.buttonText,
              includesType: findGiftInPromotionList.includesType,
            };
          } else {
            // 如果沒找到，返回原始項目或者根據你的邏輯返回一個默認值
            return item;
          }
        })
        .filter((item) => {
          const isExpired = dayjs(item.expired_date).isBefore(dayjs());
          return !isExpired;
        })
        .filter((item) => {
          if (item.includesType) {
            return item.includesType.includes(playGameType);
          } else {
            return item;
          }
        });
    }
  }, [promotionListData, i18next.language, playGameType, promotionList]);

  const handleScrollRight = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollLeft += 320; // 調整滾動速度，根據需要調整數值
      checkIfEndReached();
    }
  };

  const checkIfEndReached = () => {
    const section = sectionRef.current;
    if (section) {
      const isEnd =
        section.scrollLeft + section.clientWidth >= section.scrollWidth;
      console.log("isEnd:", isEnd);

      setIsEndReached(isEnd);
    }
  };

  return (
    <section>
      <div className="flex items-center justify-between">
        <p className="mb-2 text-2xl font-medium text-transaction-text dark:text-light-white tracking-tighter">
          {i18n_rewards("availableBonuses")}{" "}
        </p>
        {deviceType === "Mobile" &&
        updateList?.length + giftList?.length > 1 ? (
          <FaAngleDoubleRight
            className={`mb-2 ${isEndReached ? "text-white" : ""}`}
            onClick={handleScrollRight}
          />
        ) : null}
      </div>

      <LoadingReward commonLoading={apiCalling}>
        <section
          ref={(el) => {
            sectionRef.current = el;
          }}
          className="md:overflow-y-scroll overflow-x-scroll md:overflow-x-hidden no-scrollbar flex md:flex-col flex-row gap-[10px] md:gap-[0px]"
        >
          {updateList.length === 0 && giftList.length === 0 && (
            <NotFound
              hiddenButton
              customHint=" "
              icon={<TbListSearch className="text-main-color" />}
            />
          )}
          {updateList.map((item, index) => {
            const isExpired = dayjs(item.expired_date).isBefore(dayjs());
            return (
              isExpired || (
                <RewardCard
                  condition={item.condition}
                  bonusName={item.promo_label}
                  expiresIn={item.expired_date}
                  itemProps={item}
                  buttonProps={{
                    navigatePath: item.navigate,
                    text: item.buttonText,
                  }}
                  isGameBox
                  good_type="promotion"
                />
              )
            );
          })}
          {giftList.map((item, index) => {
            return (
              <UsedRewardCard
                bonusName={item.giftName}
                usedTime={item.useDate}
                usedGame={item.useGameName}
                playBet={item.playBet}
                isuse={item.isuse}
                itemProps={item}
              />
            );
          })}
        </section>
      </LoadingReward>
    </section>
  );
};

export default RewardList;
